import { render, staticRenderFns } from "./InvestmentDasboard.vue?vue&type=template&id=2fd7b620&scoped=true&"
import script from "./InvestmentDasboard.vue?vue&type=script&lang=js&"
export * from "./InvestmentDasboard.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentDasboard.vue?vue&type=style&index=0&id=2fd7b620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd7b620",
  null
  
)

export default component.exports